// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuthState } from "react-firebase-hooks/auth";
// import {
//   Copy,
//   Download,
//   Youtube,
//   Zap,
//   Target,
//   TrendingUp,
//   Image as ImageIcon,
//   CheckCircle,
//   ChevronDown,
//   ChevronUp,
//   FileText,
//   Clock,
//   Tag
// } from "lucide-react";
// import toast, { Toaster } from "react-hot-toast";
// import auth from "../../../../../firebase.init";

// const TopicResearch = () => {
//   // State management
//   const [user, loadingAuth] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [loadingKeys, setLoadingKeys] = useState(true);
//   const [loadingTools, setLoadingTools] = useState(true);
//   const [generating, setGenerating] = useState(false);
//   const [error, setError] = useState("");

//   // New Form state
//   const [keyword, setKeyword] = useState("");
//   const [audience, setAudience] = useState("");
//   const [goal, setGoal] = useState("Growth");
//   const [contentType, setContentType] = useState("Tutorials");
//   const [includeSeo, setIncludeSeo] = useState(true);
//   const [includeTags, setIncludeTags] = useState(true);

//   // Generated content section
//   const [topics, setTopics] = useState([]);
//   const [openTopicIndex, setOpenTopicIndex] = useState(0);

//   // User data
//   const [credits, setCredits] = useState(0);
  
//   // Tool Configuration
//   const [creditCost, setCreditCost] = useState(2);

//   // API keys state
//   const [apiKeys, setApiKeys] = useState([]);

//   // Options
//   const goalOptions = ["Growth", "Sales", "Authority", "Engagement"];
//   const contentOptions = [
//     "Tutorials",
//     "Reviews",
//     "Comparisons",
//     "List Videos",
//     "Explainers",
//     "Trending Topics"
//   ];

//   // Fetch API keys (Unchanged)
//   const fetchApiKeys = async () => {
//     try {
//       const response = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/gemini-keys`);
//       if (response.data && response.data.success && response.data.data) {
//         const keys = response.data.data.map((keyObj) => keyObj.key);
//         setApiKeys(keys);
//         if (keys.length === 0) setError("No API keys available. Please contact administrator.");
//       } else {
//         setError("Failed to load API keys");
//       }
//     } catch (err) {
//       console.error("Error fetching API keys:", err);
//       setError("Error loading API keys");
//     } finally {
//       setLoadingKeys(false);
//     }
//   };

//   // Fetch Tools List to determine exact Credit Cost (Unchanged)
//   const fetchToolsList = async () => {
//     try {
//       const response = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/tools-section`);
//       if (response.data && response.data.success && response.data.data && response.data.data.tools) {
//         // Keeping ID 1 to maintain unchanged credit system logic
//         const hookTool = response.data.data.tools.find(t => t.id === 2); 
//         if (hookTool) {
//             setCreditCost(hookTool.creditCost);
//         }
//       }
//     } catch (err) {
//         console.warn("Could not fetch tools list, using default credit cost");
//     } finally {
//         setLoadingTools(false);
//     }
//   };

//   const getRandomApiKey = () => {
//     if (apiKeys.length === 0) throw new Error("No API keys available");
//     return apiKeys[Math.floor(Math.random() * apiKeys.length)];
//   };

//   // Initial Data Fetch (Unchanged)
//   useEffect(() => {
//     const fetchData = async () => {
//       if (loadingAuth) return;
//       if (!user) {
//         setError("User not logged in");
//         setLoading(false);
//         setLoadingKeys(false);
//         setLoadingTools(false);
//         return;
//       }
//       try {
//         await Promise.all([fetchApiKeys(), fetchToolsList()]);
        
//         const userResponse = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/users`, {
//           params: { userEmail: user.email },
//         });
//         if (userResponse.data && userResponse.data.length > 0) {
//           const userData = userResponse.data[0];
//           setCredits(userData.currentBalance);
//         } else {
//           setError("User data not found");
//         }
//       } catch (err) {
//         console.error("Error fetching data:", err);
//         setError("Failed to load data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [user, loadingAuth]);

//   // Updated Prompt Engineering to return strict JSON
//   const constructPrompt = () => {
//     return `You are an expert YouTube growth strategist and CTR optimization expert. 
//     Generate 5 highly clickable, algorithm-friendly YouTube video topic ideas based on these parameters:
    
//     - Primary Keyword / Niche: ${keyword}
//     - Target Audience: ${audience || "General Audience"}
//     - Video Goal: ${goal}
//     - Content Type: ${contentType}
//     - Include SEO Description: ${includeSeo ? "Yes" : "No"}
//     - Include Tags: ${includeTags ? "Yes" : "No"}
    
//     CRITICAL INSTRUCTION:
//     Respond ONLY with a raw JSON array of objects. Do not include markdown blocks like \`\`\`json. Do not include any conversational text.
    
//     Each object in the array MUST follow this exact schema:
//     {
//       "title": "The core topic idea",
//       "optimizedTitle": "A curiosity-driven, highly clickable variation of the title (Max 60 chars)",
//       "whyItWorks": "1-2 sentences explaining the search intent and why the algorithm/audience will love this",
//       "hook": "A script idea for the first 30 seconds to maximize retention",
//       "format": "Suggested video format (e.g., Talking Head + B-Roll)",
//       "thumbnail": "A detailed visual description for a high-CTR thumbnail concept",
//       ${includeSeo ? '"description": "A 2-sentence SEO-optimized YouTube description snippet targeting keywords",\n' : ''}
//       ${includeTags ? '"tags": ["Tag1", "Tag2", "Tag3", "Tag4", "Tag5", "Tag6"]\n' : ''}
//     }`;
//   };

//   // Generate content (Core AI and Credit logic unchanged)
//   const generateTopics = async () => {
//     if (!keyword.trim()) {
//       setError("Please enter a Primary Keyword or Niche");
//       return;
//     }
//     if (apiKeys.length === 0) {
//       setError("No API keys available. Please try again later.");
//       return;
//     }
//     if (credits < creditCost) {
//       setError(`Insufficient credits. You need ${creditCost} credits to generate this content.`);
//       return;
//     }

//     setGenerating(true);
//     setError("");
//     setTopics([]);

//     try {
//       // Deduct credits (Unchanged)
//       const deductResponse = await axios.post(
//         `https://allyoutube-01-02d59d78beb5.herokuapp.com/api/deduct-credit`,
//         {
//           userEmail: user.email,
//           amount: creditCost,
//         }
//       );
//       if (!deductResponse.data.success) {
//         throw new Error("Failed to deduct credits");
//       }
//       setCredits((prev) => prev - creditCost);

//       // Call AI
//       const MODEL_ID = "gemini-2.5-flash-lite";
//       const apiKey = getRandomApiKey();
//       const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/${MODEL_ID}:generateContent?key=${apiKey}`;
//       const prompt = constructPrompt();

//       const response = await fetch(API_URL, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           contents: [{ role: "user", parts: [{ text: prompt }] }],
//           generationConfig: {
//             temperature: 0.8,
//             topK: 40,
//             topP: 0.95,
//             maxOutputTokens: 3000,
//           },
//         }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`API Error: ${response.status} - ${errorText}`);
//       }

//       const data = await response.json();

//       if (data.candidates && data.candidates.length > 0 && data.candidates[0].content) {
//         let generatedText = data.candidates[0].content.parts[0].text;
        
//         // Clean markdown backticks if AI sneaks them in
//         generatedText = generatedText.replace(/```json/g, '').replace(/```/g, '').trim();
        
//         try {
//           const parsedContent = JSON.parse(generatedText);
//           setTopics(parsedContent);
//           setOpenTopicIndex(0); // Open the first result automatically
//           toast.success("YouTube topic research generated!");
//         } catch (parseErr) {
//           throw new Error("AI returned invalid data format. Please try again.");
//         }
//       } else {
//         throw new Error("No content was generated from the API response");
//       }
//     } catch (err) {
//       console.error("Error generating content:", err);
//       setError(`Error: ${err.message}`);
//       toast.error(`Error: ${err.message}`);

//       // Refund credits on failure (Unchanged)
//       try {
//         await axios.post(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/refund-credit`, {
//           userEmail: user.email,
//           amount: creditCost,
//         });
//         setCredits((prev) => prev + creditCost);
//       } catch (refundErr) {
//         console.error("Error refunding credits:", refundErr);
//       }
//     } finally {
//       setGenerating(false);
//     }
//   };

//   const copyToClipboard = (text, type) => {
//     navigator.clipboard.writeText(text).then(() => {
//       toast.success(`${type} copied to clipboard!`);
//     }).catch(() => {
//       toast.error(`Failed to copy ${type.toLowerCase()}`);
//     });
//   };

//   const downloadContent = () => {
//     let allContent = `YOUTUBE TOPIC RESEARCH REPORT\n`;
//     allContent += `Keyword/Niche: ${keyword}\n`;
//     allContent += `Audience: ${audience || 'General'}\n`;
//     allContent += `Generated Topics: ${topics.length}\n\n`;
//     allContent += `===========================================\n\n`;
    
//     topics.forEach((topic, index) => {
//         allContent += `TOPIC #${index + 1}: ${topic.title.toUpperCase()}\n`;
//         allContent += `Optimized Title : ${topic.optimizedTitle}\n`;
//         allContent += `Suggested Format: ${topic.format}\n\n`;
//         allContent += `Why It Works:\n${topic.whyItWorks}\n\n`;
//         allContent += `Hook Idea (0-30s):\n${topic.hook}\n\n`;
//         allContent += `Thumbnail Concept:\n${topic.thumbnail}\n\n`;
        
//         if(topic.description) {
//             allContent += `SEO Description:\n${topic.description}\n\n`;
//         }
//         if(topic.tags && topic.tags.length > 0) {
//             allContent += `Suggested Tags:\n${topic.tags.join(', ')}\n\n`;
//         }
//         allContent += `-------------------------------------------\n\n`;
//     });

//     const blob = new Blob([allContent], { type: "text/plain" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = `${keyword.replace(/\s+/g, "-")}-yt-topics.txt`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     toast.success("Research report downloaded!");
//   };

//   const resetForm = () => {
//     setKeyword("");
//     setAudience("");
//     setGoal("Growth");
//     setContentType("Tutorials");
//     setIncludeSeo(true);
//     setIncludeTags(true);
//     setTopics([]);
//     setError("");
//   };

//   const buyMoreCredits = () => {
//     window.location.href = "/user/select-package";
//   };

//   if (loadingAuth || loading || loadingKeys || loadingTools) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
//         <div style={{ textAlign: 'center' }}>
//             <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #FF0000', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite', margin: '0 auto 10px' }}></div>
//             <p style={{ color: '#64748b', fontWeight: '500' }}>Initializing SaaS Workspace...</p>
//         </div>
     
//         <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
//       </div>
//     );
//   }

//   if (!user) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
//         <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '400px' }}>
//           <Youtube size={48} color="#FF0000" style={{ marginBottom: '1rem' }} />
//           <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontSize: '1.5rem' }}>Authentication Required</h2>
//           <button onClick={() => (window.location.href = "/login")} style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #FF0000 0%, #cc0000 100%)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', width: '100%' }}>
//             Proceed to Login
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         .yt-container { font-family: 'Inter', system-ui, -apple-system, sans-serif; background: #f8fafc; min-height: 100vh; padding: 2rem 1rem; color: #334155; }
//         .saas-card { background: #ffffff; border-radius: 16px; box-shadow: 0 4px 24px rgba(0,0,0,0.04); border: 1px solid #e2e8f0; padding: 1.5rem; transition: all 0.3s ease; }
//         .form-label { font-weight: 600; color: #475569; font-size: 0.9rem; margin-bottom: 0.5rem; display: block; }
//         .form-control, .form-select { width: 100%; padding: 0.75rem 1rem; border-radius: 10px; border: 1px solid #cbd5e1; background: #f8fafc; font-size: 0.95rem; color: #1e293b; transition: all 0.2s; margin-bottom: 1.25rem; box-sizing: border-box; }
//         .form-control:focus, .form-select:focus { outline: none; border-color: #FF0000; box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1); background: #fff; }
//         .gradient-btn { background: linear-gradient(135deg, #FF0000 0%, #D22B2B 100%); color: white; border: none; padding: 0.875rem 1.5rem; border-radius: 10px; font-weight: 600; font-size: 1rem; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 0.5rem; transition: all 0.3s ease; width: 100%; box-shadow: 0 4px 12px rgba(255,0,0,0.2); }
//         .gradient-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(255,0,0,0.3); }
//         .gradient-btn:disabled { background: #cbd5e1; box-shadow: none; cursor: not-allowed; transform: none; }
//         .outline-btn { background: transparent; border: 1px solid #cbd5e1; color: #475569; padding: 0.875rem 1.5rem; border-radius: 10px; font-weight: 600; cursor: pointer; transition: all 0.2s; width: 100%; }
//         .outline-btn:hover { background: #f1f5f9; color: #1e293b; }
//         .toggle-switch { position: relative; display: inline-block; width: 44px; height: 24px; }
//         .toggle-switch input { opacity: 0; width: 0; height: 0; }
//         .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #cbd5e1; transition: .4s; border-radius: 34px; }
//         .slider:before { position: absolute; content: ""; height: 18px; width: 18px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
//         input:checked + .slider { background-color: #10b981; }
//         input:checked + .slider:before { transform: translateX(20px); }
//         .accordion-item { border: 1px solid #e2e8f0; border-radius: 12px; margin-bottom: 1rem; background: #fff; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.02); }
//         .accordion-header { background: #fff; padding: 1.25rem 1.5rem; cursor: pointer; display: flex; justify-content: space-between; align-items: center; transition: background 0.2s; user-select: none; }
//         .accordion-header:hover { background: #f8fafc; }
//         .accordion-body { padding: 1.5rem; border-top: 1px solid #e2e8f0; background: #f8fafc; }
//         .badge { background: #fee2e2; color: #dc2626; padding: 0.35em 0.75em; border-radius: 6px; font-weight: 600; font-size: 0.75rem; display: inline-flex; align-items: center; gap: 4px;}
//         .data-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 1rem; margin-bottom: 1rem; }
//         .data-label { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em; color: #64748b; font-weight: 700; margin-bottom: 0.5rem; display: flex; align-items: center; gap: 6px;}
//         @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
//         .animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
//       `}</style>

//       <div className="yt-container">
//         <Toaster position="top-right" />
        
//         <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
//           {/* Top Navigation Bar */}
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "2rem" }}>
//             <button onClick={() => window.history.back()} style={{ background: "#fff", border: "1px solid #e2e8f0", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", fontWeight: "500", color: "#475569", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>
//               ← Back to Dashboard
//             </button>
//             <div style={{ display: "flex", alignItems: "center", gap: "15px", background: "white", padding: "8px 20px", borderRadius: "30px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)", border: "1px solid #e2e8f0" }}>
//               <span style={{ fontWeight: "600", color: "#64748b", fontSize: "0.9rem" }}>Available Credits:</span>
//               <span style={{ color: credits < creditCost ? "#ef4444" : "#10b981", fontWeight: "800", fontSize: "1.1rem" }}>{credits}</span>
//               {credits < creditCost && (
//                 <button onClick={buyMoreCredits} style={{ background: "#10b981", color: "white", border: "none", padding: "6px 14px", borderRadius: "20px", cursor: "pointer", fontSize: "0.8rem", fontWeight: "600" }}>
//                   Refill
//                 </button>
//               )}
//             </div>
//           </div>

//           {/* Header */}
//           <div style={{ textAlign: "center", marginBottom: "3rem" }}>
//             <h1 style={{ fontSize: "2.5rem", fontWeight: "800", margin: "0", color: "#0f172a", display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", letterSpacing: "-0.02em" }}>
//               <Youtube color="#FF0000" size={40} /> YouTube Topic Research
//             </h1>
//             <p style={{ color: "#64748b", marginTop: "12px", fontSize: "1.1rem", maxWidth: "600px", margin: "12px auto 0" }}>
//               Discover high-potential, click-worthy video ideas optimized for the YouTube algorithm in seconds.
//             </p>
//           </div>

//           {error && (
//             <div style={{ background: "#fef2f2", color: "#ef4444", padding: "1rem", borderRadius: "10px", marginBottom: "2rem", textAlign: "center", border: "1px solid #fecaca", fontWeight: "500" }}>
//               {error}
//             </div>
//           )}

//           <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', margin: 0 }}>
            
//             {/* Left Side - Input Form */}
//             <div style={{ flex: '1 1 350px', maxWidth: '450px' }}>
//               <div className="saas-card">
//                 <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid #f1f5f9' }}>
//                   <Target size={20} color="#FF0000" />
//                   <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#0f172a', fontWeight: '700' }}>Targeting Parameters</h3>
//                 </div>
                
//                 <label className="form-label">Primary Keyword or Niche <span style={{color:'#ef4444'}}>*</span></label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={keyword}
//                   onChange={(e) => setKeyword(e.target.value)}
//                   placeholder="e.g., Notion setup, AI tools, Fitness for beginners"
//                 />

//                 <label className="form-label">Target Audience (Optional)</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={audience}
//                   onChange={(e) => setAudience(e.target.value)}
//                   placeholder="e.g., College students, Freelancers"
//                 />

//                 <div style={{ display: 'flex', gap: '1rem' }}>
//                   <div style={{ flex: 1 }}>
//                     <label className="form-label">Video Goal</label>
//                     <select className="form-select" value={goal} onChange={(e) => setGoal(e.target.value)}>
//                       {goalOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//                     </select>
//                   </div>
//                   <div style={{ flex: 1 }}>
//                     <label className="form-label">Content Type</label>
//                     <select className="form-select" value={contentType} onChange={(e) => setContentType(e.target.value)}>
//                       {contentOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
//                     </select>
//                   </div>
//                 </div>

//                 <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '10px', marginTop: '0.5rem', marginBottom: '1.5rem', border: '1px solid #e2e8f0' }}>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
//                     <div>
//                       <span style={{ fontWeight: '600', color: '#334155', display: 'block', fontSize: '0.9rem' }}>Include SEO Description</span>
//                       <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Generate description snippet</span>
//                     </div>
//                     <label className="toggle-switch">
//                       <input type="checkbox" checked={includeSeo} onChange={(e) => setIncludeSeo(e.target.checked)} />
//                       <span className="slider"></span>
//                     </label>
//                   </div>
//                   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                     <div>
//                       <span style={{ fontWeight: '600', color: '#334155', display: 'block', fontSize: '0.9rem' }}>Include Tags</span>
//                       <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Suggest optimized tags</span>
//                     </div>
//                     <label className="toggle-switch">
//                       <input type="checkbox" checked={includeTags} onChange={(e) => setIncludeTags(e.target.checked)} />
//                       <span className="slider"></span>
//                     </label>
//                   </div>
//                 </div>

//                 <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
//                   <button onClick={generateTopics} disabled={generating || !keyword.trim() || credits < creditCost} className="gradient-btn">
//                     {generating ? <Clock size={18} className="animate-spin" /> : <Zap size={18} fill="currentColor" />}
//                     {generating ? "Analyzing Algorithm..." : `Generate Topics (${creditCost} Credits)`}
//                   </button>
//                   <button onClick={resetForm} className="outline-btn">
//                     Reset Form
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Right Side - Output */}
//             <div style={{ flex: '1 1 500px' }}>
              
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
//                 <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#0f172a", fontWeight: "700" }}>Research Insights</h2>
//                 {topics.length > 0 && (
//                   <button onClick={downloadContent} style={{ background: "#fff", color: "#0f172a", border: "1px solid #cbd5e1", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "0.9rem", fontWeight: "600", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>
//                     <Download size={16} /> Export Data
//                   </button>
//                 )}
//               </div>

//               {generating ? (
//                  <div className="saas-card" style={{ textAlign: "center", padding: "4rem 2rem" }}>
//                     <div className="animate-pulse" style={{ width: '60px', height: '60px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
//                       <TrendingUp size={30} color="#FF0000" />
//                     </div>
//                     <h3 style={{ color: '#0f172a', fontWeight: '700', marginBottom: '0.5rem' }}>Scouring the YouTube Algorithm...</h3>
//                     <p style={{ color: "#64748b" }}>Analyzing search intent, identifying content gaps, and crafting click-worthy angles.</p>
//                  </div>
//               ) : topics.length > 0 ? (
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                   {topics.map((topic, index) => (
//                     <div key={index} className="accordion-item">
//                       <div className="accordion-header" onClick={() => setOpenTopicIndex(openTopicIndex === index ? null : index)}>
//                         <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, paddingRight: '1rem' }}>
//                           <div style={{ background: '#f1f5f9', color: '#64748b', fontWeight: '800', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                             {index + 1}
//                           </div>
//                           <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b', fontWeight: '700', lineHeight: '1.4' }}>
//                             {topic.optimizedTitle}
//                           </h4>
//                         </div>
//                         {openTopicIndex === index ? <ChevronUp size={20} color="#64748b" /> : <ChevronDown size={20} color="#64748b" />}
//                       </div>
                      
//                       {openTopicIndex === index && (
//                         <div className="accordion-body">
//                           <div style={{ display: 'flex', gap: '10px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
//                             <span className="badge"><Youtube size={14} /> Topic: {topic.title}</span>
//                             <span className="badge" style={{ background: '#e0e7ff', color: '#4338ca' }}><FileText size={14} /> Format: {topic.format}</span>
//                           </div>

//                           <div className="data-card" style={{ borderLeft: '4px solid #10b981' }}>
//                             <div className="data-label"><TrendingUp size={14} /> Why This Angle Works</div>
//                             <p style={{ margin: 0, color: '#334155', lineHeight: '1.6' }}>{topic.whyItWorks}</p>
//                           </div>

//                           <div className="data-card" style={{ background: '#fffbeb', borderLeft: '4px solid #f59e0b', position: 'relative' }}>
//                              <button onClick={() => copyToClipboard(topic.hook, "Hook")} style={{ position: 'absolute', top: '10px', right: '10px', background: 'transparent', border: 'none', color: '#92400e', cursor: 'pointer' }}><Copy size={16} /></button>
//                             <div className="data-label" style={{ color: '#92400e' }}><Zap size={14} fill="currentColor" /> The 30-Second Hook</div>
//                             <p style={{ margin: 0, color: '#78350f', lineHeight: '1.6', fontStyle: 'italic', paddingRight: '20px' }}>"{topic.hook}"</p>
//                           </div>

//                           <div className="data-card" style={{ borderLeft: '4px solid #ec4899' }}>
//                             <div className="data-label" style={{ color: '#be185d' }}><ImageIcon size={14} /> Thumbnail Concept</div>
//                             <p style={{ margin: 0, color: '#334155', lineHeight: '1.6' }}>{topic.thumbnail}</p>
//                           </div>

//                           {(topic.description || (topic.tags && topic.tags.length > 0)) && (
//                             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
//                               {topic.description && (
//                                 <div className="data-card" style={{ marginBottom: 0, background: '#f8fafc' }}>
//                                   <div className="data-label" style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{display:'flex', alignItems:'center', gap:'6px'}}><CheckCircle size={14} /> SEO Snippet</span>
//                                     <button onClick={() => copyToClipboard(topic.description, "Description")} style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', padding: 0 }}><Copy size={14} /></button>
//                                   </div>
//                                   <p style={{ margin: 0, color: '#475569', fontSize: '0.9rem', lineHeight: '1.5' }}>{topic.description}</p>
//                                 </div>
//                               )}
                              
//                               {topic.tags && topic.tags.length > 0 && (
//                                 <div className="data-card" style={{ marginBottom: 0, background: '#f8fafc' }}>
//                                   <div className="data-label" style={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <span style={{display:'flex', alignItems:'center', gap:'6px'}}><Tag size={14} /> Target Tags</span>
//                                     <button onClick={() => copyToClipboard(topic.tags.join(', '), "Tags")} style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', padding: 0 }}><Copy size={14} /></button>
//                                   </div>
//                                   <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
//                                     {topic.tags.map(tag => (
//                                       <span key={tag} style={{ background: '#e2e8f0', color: '#334155', padding: '4px 8px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: '500' }}>#{tag}</span>
//                                     ))}
//                                   </div>
//                                 </div>
//                               )}
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="saas-card" style={{ textAlign: 'center', padding: '4rem 2rem', border: '2px dashed #cbd5e1', background: 'transparent', boxShadow: 'none' }}>
//                   <Youtube size={40} color="#cbd5e1" style={{ marginBottom: '1rem' }} />
//                   <h3 style={{ color: '#64748b', fontWeight: '600', margin: '0 0 0.5rem 0' }}>Ready to Research</h3>
//                   <p style={{ color: '#94a3b8', margin: 0 }}>Configure your targeting parameters on the left and hit generate to uncover viral angles.</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TopicResearch;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  Copy,
  Download,
  Youtube,
  Zap,
  Target,
  TrendingUp,
  Image as ImageIcon,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  FileText,
  Clock,
  Tag
} from "lucide-react";
import toast, { Toaster } from "react-hot-toast";
import auth from "../../../../../firebase.init";

const TopicResearch = () => {
  // State management
  const [user, loadingAuth] = useAuthState(auth);
  const [loading, setLoading] = useState(true);
  const [loadingKeys, setLoadingKeys] = useState(true);
  const [loadingTools, setLoadingTools] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState("");

  // New Form state
  const [keyword, setKeyword] = useState("");
  const [audience, setAudience] = useState("General Audience");
  const [goal, setGoal] = useState("Growth");
  const [contentType, setContentType] = useState("Tutorials");
  const [includeSeo, setIncludeSeo] = useState(true);
  const [includeTags, setIncludeTags] = useState(true);

  // Generated content section
  const [topics, setTopics] = useState([]);
  const [openTopicIndex, setOpenTopicIndex] = useState(0);

  // User data
  const [credits, setCredits] = useState(0);
  
  // Tool Configuration
  const [creditCost, setCreditCost] = useState(2);

  // API keys state
  const [apiKeys, setApiKeys] = useState([]);

  // Options
  const audienceOptions = [
    "General Audience",
    "Beginners / Novices",
    "Professionals / Experts",
    "Students",
    "Entrepreneurs / Founders",
    "Content Creators",
    "Gamers",
    "Tech Enthusiasts",
    "Fitness Enthusiasts",
    "Parents"
  ];

  const goalOptions = ["Growth", "Sales", "Authority", "Engagement"];
  
  const contentOptions = [
    "Tutorials",
    "Reviews",
    "Comparisons",
    "List Videos",
    "Explainers",
    "Trending Topics"
  ];

  // Fetch API keys (Unchanged)
  const fetchApiKeys = async () => {
    try {
      const response = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/gemini-keys`);
      if (response.data && response.data.success && response.data.data) {
        const keys = response.data.data.map((keyObj) => keyObj.key);
        setApiKeys(keys);
        if (keys.length === 0) setError("No API keys available. Please contact administrator.");
      } else {
        setError("Failed to load API keys");
      }
    } catch (err) {
      console.error("Error fetching API keys:", err);
      setError("Error loading API keys");
    } finally {
      setLoadingKeys(false);
    }
  };

  // Fetch Tools List to determine exact Credit Cost (Unchanged)
  const fetchToolsList = async () => {
    try {
      const response = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/tools-section`);
      if (response.data && response.data.success && response.data.data && response.data.data.tools) {
        // Keeping ID 1 to maintain unchanged credit system logic
        const hookTool = response.data.data.tools.find(t => t.id === 2); 
        if (hookTool) {
            setCreditCost(hookTool.creditCost);
        }
      }
    } catch (err) {
        console.warn("Could not fetch tools list, using default credit cost");
    } finally {
        setLoadingTools(false);
    }
  };

  const getRandomApiKey = () => {
    if (apiKeys.length === 0) throw new Error("No API keys available");
    return apiKeys[Math.floor(Math.random() * apiKeys.length)];
  };

  // Initial Data Fetch (Unchanged)
  useEffect(() => {
    const fetchData = async () => {
      if (loadingAuth) return;
      if (!user) {
        setError("User not logged in");
        setLoading(false);
        setLoadingKeys(false);
        setLoadingTools(false);
        return;
      }
      try {
        await Promise.all([fetchApiKeys(), fetchToolsList()]);
        
        const userResponse = await axios.get(`https://allyoutube-01-02d59d78beb5.herokuapp.com/users`, {
          params: { userEmail: user.email },
        });
        if (userResponse.data && userResponse.data.length > 0) {
          const userData = userResponse.data[0];
          setCredits(userData.currentBalance);
        } else {
          setError("User data not found");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [user, loadingAuth]);

  // Updated Prompt Engineering to return strict JSON
  const constructPrompt = () => {
    return `You are an expert YouTube growth strategist and CTR optimization expert. 
    Generate 5 highly clickable, algorithm-friendly YouTube video topic ideas based on these parameters:
    
    - Primary Keyword / Niche: ${keyword}
    - Target Audience: ${audience}
    - Video Goal: ${goal}
    - Content Type: ${contentType}
    - Include SEO Description: ${includeSeo ? "Yes" : "No"}
    - Include Tags: ${includeTags ? "Yes" : "No"}
    
    CRITICAL INSTRUCTION:
    Respond ONLY with a raw JSON array of objects. Do not include markdown blocks like \`\`\`json. Do not include any conversational text.
    
    Each object in the array MUST follow this exact schema:
    {
      "title": "The core topic idea",
      "optimizedTitle": "A curiosity-driven, highly clickable variation of the title (Max 60 chars)",
      "whyItWorks": "1-2 sentences explaining the search intent and why the algorithm/audience will love this",
      "hook": "A script idea for the first 30 seconds to maximize retention",
      "format": "Suggested video format (e.g., Talking Head + B-Roll)",
      "thumbnail": "A detailed visual description for a high-CTR thumbnail concept",
      ${includeSeo ? '"description": "A 2-sentence SEO-optimized YouTube description snippet targeting keywords",\n' : ''}
      ${includeTags ? '"tags": ["Tag1", "Tag2", "Tag3", "Tag4", "Tag5", "Tag6"]\n' : ''}
    }`;
  };

  // Generate content (Core AI and Credit logic unchanged)
  const generateTopics = async () => {
    if (!keyword.trim()) {
      setError("Please enter a Primary Keyword or Niche");
      return;
    }
    if (apiKeys.length === 0) {
      setError("No API keys available. Please try again later.");
      return;
    }
    if (credits < creditCost) {
      setError(`Insufficient credits. You need ${creditCost} credits to generate this content.`);
      return;
    }

    setGenerating(true);
    setError("");
    setTopics([]);

    try {
      // Deduct credits (Unchanged)
      const deductResponse = await axios.post(
        `https://allyoutube-01-02d59d78beb5.herokuapp.com/api/deduct-credit`,
        {
          userEmail: user.email,
          amount: creditCost,
        }
      );
      if (!deductResponse.data.success) {
        throw new Error("Failed to deduct credits");
      }
      setCredits((prev) => prev - creditCost);

      // Call AI
      const MODEL_ID = "gemini-2.5-flash-lite";
      const apiKey = getRandomApiKey();
      const API_URL = `https://generativelanguage.googleapis.com/v1beta/models/${MODEL_ID}:generateContent?key=${apiKey}`;
      const prompt = constructPrompt();

      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [{ role: "user", parts: [{ text: prompt }] }],
          generationConfig: {
            temperature: 0.8,
            topK: 40,
            topP: 0.95,
            maxOutputTokens: 3000,
          },
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`API Error: ${response.status} - ${errorText}`);
      }

      const data = await response.json();

      if (data.candidates && data.candidates.length > 0 && data.candidates[0].content) {
        let generatedText = data.candidates[0].content.parts[0].text;
        
        // Clean markdown backticks if AI sneaks them in
        generatedText = generatedText.replace(/```json/g, '').replace(/```/g, '').trim();
        
        try {
          const parsedContent = JSON.parse(generatedText);
          setTopics(parsedContent);
          setOpenTopicIndex(0); // Open the first result automatically
          toast.success("YouTube topic research generated!");
        } catch (parseErr) {
          throw new Error("AI returned invalid data format. Please try again.");
        }
      } else {
        throw new Error("No content was generated from the API response");
      }
    } catch (err) {
      console.error("Error generating content:", err);
      setError(`Error: ${err.message}`);
      toast.error(`Error: ${err.message}`);

      // Refund credits on failure (Unchanged)
      try {
        await axios.post(`https://allyoutube-01-02d59d78beb5.herokuapp.com/api/refund-credit`, {
          userEmail: user.email,
          amount: creditCost,
        });
        setCredits((prev) => prev + creditCost);
      } catch (refundErr) {
        console.error("Error refunding credits:", refundErr);
      }
    } finally {
      setGenerating(false);
    }
  };

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success(`${type} copied to clipboard!`);
    }).catch(() => {
      toast.error(`Failed to copy ${type.toLowerCase()}`);
    });
  };

  const downloadContent = () => {
    let allContent = `YOUTUBE TOPIC RESEARCH REPORT\n`;
    allContent += `Keyword/Niche: ${keyword}\n`;
    allContent += `Audience: ${audience}\n`;
    allContent += `Generated Topics: ${topics.length}\n\n`;
    allContent += `===========================================\n\n`;
    
    topics.forEach((topic, index) => {
        allContent += `TOPIC #${index + 1}: ${topic.title.toUpperCase()}\n`;
        allContent += `Optimized Title : ${topic.optimizedTitle}\n`;
        allContent += `Suggested Format: ${topic.format}\n\n`;
        allContent += `Why It Works:\n${topic.whyItWorks}\n\n`;
        allContent += `Hook Idea (0-30s):\n${topic.hook}\n\n`;
        allContent += `Thumbnail Concept:\n${topic.thumbnail}\n\n`;
        
        if(topic.description) {
            allContent += `SEO Description:\n${topic.description}\n\n`;
        }
        if(topic.tags && topic.tags.length > 0) {
            allContent += `Suggested Tags:\n${topic.tags.join(', ')}\n\n`;
        }
        allContent += `-------------------------------------------\n\n`;
    });

    const blob = new Blob([allContent], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${keyword.replace(/\s+/g, "-")}-yt-topics.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("Research report downloaded!");
  };

  const resetForm = () => {
    setKeyword("");
    setAudience("General Audience");
    setGoal("Growth");
    setContentType("Tutorials");
    setIncludeSeo(true);
    setIncludeTags(true);
    setTopics([]);
    setError("");
  };

  const buyMoreCredits = () => {
    window.location.href = "/user/select-package";
  };

  if (loadingAuth || loading || loadingKeys || loadingTools) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
        <div style={{ textAlign: 'center' }}>
            <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #FF0000', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite', margin: '0 auto 10px' }}></div>
            <p style={{ color: '#64748b', fontWeight: '500' }}>Initializing SaaS Workspace...</p>
        </div>
     
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f8fafc' }}>
        <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 10px 40px rgba(0,0,0,0.08)', textAlign: 'center', maxWidth: '400px' }}>
          <Youtube size={48} color="#FF0000" style={{ marginBottom: '1rem' }} />
          <h2 style={{ color: '#1e293b', marginBottom: '1.5rem', fontSize: '1.5rem' }}>Authentication Required</h2>
          <button onClick={() => (window.location.href = "/login")} style={{ padding: '12px 24px', background: 'linear-gradient(135deg, #FF0000 0%, #cc0000 100%)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', width: '100%' }}>
            Proceed to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <style>{`
        .yt-container { font-family: 'Inter', system-ui, -apple-system, sans-serif; background: #f8fafc; min-height: 100vh; padding: 2rem 1rem; color: #334155; }
        .saas-card { background: #ffffff; border-radius: 16px; box-shadow: 0 4px 24px rgba(0,0,0,0.04); border: 1px solid #e2e8f0; padding: 1.5rem; transition: all 0.3s ease; }
        .form-label { font-weight: 600; color: #475569; font-size: 0.9rem; margin-bottom: 0.5rem; display: block; }
        .form-control, .form-select { width: 100%; padding: 0.75rem 1rem; border-radius: 10px; border: 1px solid #cbd5e1; background: #f8fafc; font-size: 0.95rem; color: #1e293b; transition: all 0.2s; margin-bottom: 1.25rem; box-sizing: border-box; }
        .form-control:focus, .form-select:focus { outline: none; border-color: #FF0000; box-shadow: 0 0 0 3px rgba(255, 0, 0, 0.1); background: #fff; }
        .gradient-btn { background: linear-gradient(135deg, #FF0000 0%, #D22B2B 100%); color: white; border: none; padding: 0.875rem 1.5rem; border-radius: 10px; font-weight: 600; font-size: 1rem; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 0.5rem; transition: all 0.3s ease; width: 100%; box-shadow: 0 4px 12px rgba(255,0,0,0.2); }
        .gradient-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(255,0,0,0.3); }
        .gradient-btn:disabled { background: #cbd5e1; box-shadow: none; cursor: not-allowed; transform: none; }
        .outline-btn { background: transparent; border: 1px solid #cbd5e1; color: #475569; padding: 0.875rem 1.5rem; border-radius: 10px; font-weight: 600; cursor: pointer; transition: all 0.2s; width: 100%; }
        .outline-btn:hover { background: #f1f5f9; color: #1e293b; }
        .toggle-switch { position: relative; display: inline-block; width: 44px; height: 24px; }
        .toggle-switch input { opacity: 0; width: 0; height: 0; }
        .slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: #cbd5e1; transition: .4s; border-radius: 34px; }
        .slider:before { position: absolute; content: ""; height: 18px; width: 18px; left: 3px; bottom: 3px; background-color: white; transition: .4s; border-radius: 50%; }
        input:checked + .slider { background-color: #10b981; }
        input:checked + .slider:before { transform: translateX(20px); }
        .accordion-item { border: 1px solid #e2e8f0; border-radius: 12px; margin-bottom: 1rem; background: #fff; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.02); }
        .accordion-header { background: #fff; padding: 1.25rem 1.5rem; cursor: pointer; display: flex; justify-content: space-between; align-items: center; transition: background 0.2s; user-select: none; }
        .accordion-header:hover { background: #f8fafc; }
        .accordion-body { padding: 1.5rem; border-top: 1px solid #e2e8f0; background: #f8fafc; }
        .badge { background: #fee2e2; color: #dc2626; padding: 0.35em 0.75em; border-radius: 6px; font-weight: 600; font-size: 0.75rem; display: inline-flex; align-items: center; gap: 4px;}
        .data-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 1rem; margin-bottom: 1rem; }
        .data-label { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.05em; color: #64748b; font-weight: 700; margin-bottom: 0.5rem; display: flex; align-items: center; gap: 6px;}
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }
        .animate-pulse { animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite; }
      `}</style>

      <div className="yt-container">
        <Toaster position="top-right" />
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Top Navigation Bar */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "2rem" }}>
            <button onClick={() => window.history.back()} style={{ background: "#fff", border: "1px solid #e2e8f0", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px", fontWeight: "500", color: "#475569", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>
              ← Back to Dashboard
            </button>
            <div style={{ display: "flex", alignItems: "center", gap: "15px", background: "white", padding: "8px 20px", borderRadius: "30px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)", border: "1px solid #e2e8f0" }}>
              <span style={{ fontWeight: "600", color: "#64748b", fontSize: "0.9rem" }}>Available Credits:</span>
              <span style={{ color: credits < creditCost ? "#ef4444" : "#10b981", fontWeight: "800", fontSize: "1.1rem" }}>{credits}</span>
              {credits < creditCost && (
                <button onClick={buyMoreCredits} style={{ background: "#10b981", color: "white", border: "none", padding: "6px 14px", borderRadius: "20px", cursor: "pointer", fontSize: "0.8rem", fontWeight: "600" }}>
                  Refill
                </button>
              )}
            </div>
          </div>

          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <h1 style={{ fontSize: "2.5rem", fontWeight: "800", margin: "0", color: "#0f172a", display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", letterSpacing: "-0.02em" }}>
              <Youtube color="#FF0000" size={40} /> YouTube Topic Research
            </h1>
            <p style={{ color: "#64748b", marginTop: "12px", fontSize: "1.1rem", maxWidth: "600px", margin: "12px auto 0" }}>
              Discover high-potential, click-worthy video ideas optimized for the YouTube algorithm in seconds.
            </p>
          </div>

          {error && (
            <div style={{ background: "#fef2f2", color: "#ef4444", padding: "1rem", borderRadius: "10px", marginBottom: "2rem", textAlign: "center", border: "1px solid #fecaca", fontWeight: "500" }}>
              {error}
            </div>
          )}

          <div className="row" style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', margin: 0 }}>
            
            {/* Left Side - Input Form */}
            <div style={{ flex: '1 1 350px', maxWidth: '450px' }}>
              <div className="saas-card">
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid #f1f5f9' }}>
                  <Target size={20} color="#FF0000" />
                  <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#0f172a', fontWeight: '700' }}>Targeting Parameters</h3>
                </div>
                
                <label className="form-label">Primary Keyword or Niche <span style={{color:'#ef4444'}}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="e.g., Notion setup, AI tools, Fitness for beginners"
                />

                <label className="form-label">Target Audience</label>
                <select 
                  className="form-select" 
                  value={audience} 
                  onChange={(e) => setAudience(e.target.value)}
                >
                  {audienceOptions.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>

                <div style={{ display: 'flex', gap: '1rem' }}>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Video Goal</label>
                    <select className="form-select" value={goal} onChange={(e) => setGoal(e.target.value)}>
                      {goalOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Content Type</label>
                    <select className="form-select" value={contentType} onChange={(e) => setContentType(e.target.value)}>
                      {contentOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </select>
                  </div>
                </div>

                <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '10px', marginTop: '0.5rem', marginBottom: '1.5rem', border: '1px solid #e2e8f0' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                    <div>
                      <span style={{ fontWeight: '600', color: '#334155', display: 'block', fontSize: '0.9rem' }}>Include SEO Description</span>
                      <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Generate description snippet</span>
                    </div>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={includeSeo} onChange={(e) => setIncludeSeo(e.target.checked)} />
                      <span className="slider"></span>
                    </label>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <span style={{ fontWeight: '600', color: '#334155', display: 'block', fontSize: '0.9rem' }}>Include Tags</span>
                      <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Suggest optimized tags</span>
                    </div>
                    <label className="toggle-switch">
                      <input type="checkbox" checked={includeTags} onChange={(e) => setIncludeTags(e.target.checked)} />
                      <span className="slider"></span>
                    </label>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
                  <button onClick={generateTopics} disabled={generating || !keyword.trim() || credits < creditCost} className="gradient-btn">
                    {generating ? <Clock size={18} className="animate-spin" /> : <Zap size={18} fill="currentColor" />}
                    {generating ? "Analyzing Algorithm..." : `Generate Topics (${creditCost} Credits)`}
                  </button>
                  <button onClick={resetForm} className="outline-btn">
                    Reset Form
                  </button>
                </div>
              </div>
            </div>

            {/* Right Side - Output */}
            <div style={{ flex: '1 1 500px' }}>
              
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.5rem" }}>
                <h2 style={{ margin: 0, fontSize: "1.5rem", color: "#0f172a", fontWeight: "700" }}>Research Insights</h2>
                {topics.length > 0 && (
                  <button onClick={downloadContent} style={{ background: "#fff", color: "#0f172a", border: "1px solid #cbd5e1", padding: "8px 16px", borderRadius: "8px", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px", fontSize: "0.9rem", fontWeight: "600", boxShadow: "0 2px 4px rgba(0,0,0,0.02)" }}>
                    <Download size={16} /> Export Data
                  </button>
                )}
              </div>

              {generating ? (
                 <div className="saas-card" style={{ textAlign: "center", padding: "4rem 2rem" }}>
                    <div className="animate-pulse" style={{ width: '60px', height: '60px', background: '#fee2e2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.5rem' }}>
                      <TrendingUp size={30} color="#FF0000" />
                    </div>
                    <h3 style={{ color: '#0f172a', fontWeight: '700', marginBottom: '0.5rem' }}>Scouring the YouTube Algorithm...</h3>
                    <p style={{ color: "#64748b" }}>Analyzing search intent, identifying content gaps, and crafting click-worthy angles.</p>
                 </div>
              ) : topics.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {topics.map((topic, index) => (
                    <div key={index} className="accordion-item">
                      <div className="accordion-header" onClick={() => setOpenTopicIndex(openTopicIndex === index ? null : index)}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1, paddingRight: '1rem' }}>
                          <div style={{ background: '#f1f5f9', color: '#64748b', fontWeight: '800', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            {index + 1}
                          </div>
                          <h4 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b', fontWeight: '700', lineHeight: '1.4' }}>
                            {topic.optimizedTitle}
                          </h4>
                        </div>
                        {openTopicIndex === index ? <ChevronUp size={20} color="#64748b" /> : <ChevronDown size={20} color="#64748b" />}
                      </div>
                      
                      {openTopicIndex === index && (
                        <div className="accordion-body">
                          <div style={{ display: 'flex', gap: '10px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                            <span className="badge"><Youtube size={14} /> Topic: {topic.title}</span>
                            <span className="badge" style={{ background: '#e0e7ff', color: '#4338ca' }}><FileText size={14} /> Format: {topic.format}</span>
                          </div>

                          <div className="data-card" style={{ borderLeft: '4px solid #10b981' }}>
                            <div className="data-label"><TrendingUp size={14} /> Why This Angle Works</div>
                            <p style={{ margin: 0, color: '#334155', lineHeight: '1.6' }}>{topic.whyItWorks}</p>
                          </div>

                          <div className="data-card" style={{ background: '#fffbeb', borderLeft: '4px solid #f59e0b', position: 'relative' }}>
                             <button onClick={() => copyToClipboard(topic.hook, "Hook")} style={{ position: 'absolute', top: '10px', right: '10px', background: 'transparent', border: 'none', color: '#92400e', cursor: 'pointer' }}><Copy size={16} /></button>
                            <div className="data-label" style={{ color: '#92400e' }}><Zap size={14} fill="currentColor" /> The 30-Second Hook</div>
                            <p style={{ margin: 0, color: '#78350f', lineHeight: '1.6', fontStyle: 'italic', paddingRight: '20px' }}>"{topic.hook}"</p>
                          </div>

                          <div className="data-card" style={{ borderLeft: '4px solid #ec4899' }}>
                            <div className="data-label" style={{ color: '#be185d' }}><ImageIcon size={14} /> Thumbnail Concept</div>
                            <p style={{ margin: 0, color: '#334155', lineHeight: '1.6' }}>{topic.thumbnail}</p>
                          </div>

                          {(topic.description || (topic.tags && topic.tags.length > 0)) && (
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginTop: '1rem' }}>
                              {topic.description && (
                                <div className="data-card" style={{ marginBottom: 0, background: '#f8fafc' }}>
                                  <div className="data-label" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{display:'flex', alignItems:'center', gap:'6px'}}><CheckCircle size={14} /> SEO Snippet</span>
                                    <button onClick={() => copyToClipboard(topic.description, "Description")} style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', padding: 0 }}><Copy size={14} /></button>
                                  </div>
                                  <p style={{ margin: 0, color: '#475569', fontSize: '0.9rem', lineHeight: '1.5' }}>{topic.description}</p>
                                </div>
                              )}
                              
                              {topic.tags && topic.tags.length > 0 && (
                                <div className="data-card" style={{ marginBottom: 0, background: '#f8fafc' }}>
                                  <div className="data-label" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <span style={{display:'flex', alignItems:'center', gap:'6px'}}><Tag size={14} /> Target Tags</span>
                                    <button onClick={() => copyToClipboard(topic.tags.join(', '), "Tags")} style={{ background: 'transparent', border: 'none', color: '#64748b', cursor: 'pointer', padding: 0 }}><Copy size={14} /></button>
                                  </div>
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                    {topic.tags.map(tag => (
                                      <span key={tag} style={{ background: '#e2e8f0', color: '#334155', padding: '4px 8px', borderRadius: '4px', fontSize: '0.8rem', fontWeight: '500' }}>#{tag}</span>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="saas-card" style={{ textAlign: 'center', padding: '4rem 2rem', border: '2px dashed #cbd5e1', background: 'transparent', boxShadow: 'none' }}>
                  <Youtube size={40} color="#cbd5e1" style={{ marginBottom: '1rem' }} />
                  <h3 style={{ color: '#64748b', fontWeight: '600', margin: '0 0 0.5rem 0' }}>Ready to Research</h3>
                  <p style={{ color: '#94a3b8', margin: 0 }}>Configure your targeting parameters on the left and hit generate to uncover viral angles.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopicResearch;